import f_illustration_1 from "../../../Assets/ServicesPage_Assets/Illustration_1.png";
import f_illustration_2 from "../../../Assets/ServicesPage_Assets/Illustration_2.png";
import f_illustration_3 from "../../../Assets/ServicesPage_Assets/Illustration_3.png";
import f_illustration_4 from "../../../Assets/ServicesPage_Assets/Illustration_4.png";
import f_illustration_5 from "../../../Assets/ServicesPage_Assets/Illustration_5.png";
import ui_ux_new from "../../../Assets/ServicesPage_Assets/ui-ux.png";
import webdev from "../../../Assets/ServicesPage_Assets/FrontendDevelopment.jpg";

import backend from "../../../Assets/ServicesPage_Assets/backend.png";
import appdev from "../../../Assets/ServicesPage_Assets/AndroidDevelopment.png";
import b_illustration_1 from "../../../Assets/ServicesPage_Assets/B_Illustration_1.png";
import b_illustration_2 from "../../../Assets/ServicesPage_Assets/B_Illustration_2.jpg";
import b_illustration_3 from "../../../Assets/ServicesPage_Assets/B_Illustration_3.jpg";
import b_illustration_4 from "../../../Assets/ServicesPage_Assets/B_Illustration_4.png";

import a_illustration_1 from "../../../Assets/ServicesPage_Assets/A_Illustration_1.png";
import a_illustration_2 from "../../../Assets/ServicesPage_Assets/A_Illustration_2.png";
import a_illustration_3 from "../../../Assets/ServicesPage_Assets/A_Illustration_3.png";
import a_illustration_4 from "../../../Assets/ServicesPage_Assets/A_Illustration_4.png";
import a_illustration_5 from "../../../Assets/ServicesPage_Assets/U_Illustration_5.jpg";

import u_illustration_1 from "../../../Assets/ServicesPage_Assets/U_Illustration_1.png";
import u_illustration_2 from "../../../Assets/ServicesPage_Assets/U_Illustration_2.png";
import u_illustration_3 from "../../../Assets/ServicesPage_Assets/U_Illustration_3.png";
import u_illustration_4 from "../../../Assets/ServicesPage_Assets/U_Illustration_4.png";
import u_illustration_5 from "../../../Assets/ServicesPage_Assets/U_Illustration_5.jpg";

export const frontend_data = [
  {
    img: f_illustration_1,
    title: "DESIGNING A WEBSITE",
    points: [
      "UI/UX Fundamentals",
      "Introduction to HTML",
      "Styling with CSS Implementation",
    ],
    color: "#008957",
  },
  {
    img: f_illustration_2,
    title: "Diving into CSS",
    points: [
      "Responsive design using flexbox",
      "Understanding Usecases",
      "Master Flexbox",
    ],
    color: "#7C44B6",
  },
  {
    img: f_illustration_3,
    title: "Master Responsive designs",
    points: [
      "Media Queries",
      "Creating Animations",
      "Using animations in real world examples",
    ],
    color: "#0038FF",
  },
  {
    img: f_illustration_4,
    title: "JavaScript Fundamentals",
    points: [
      "Introduction to JavaScript",
      "Working with Variables and Data Types",
      "Conditional Statements and Loops",
      "Functions and DOM Manipulation Basics",
    ],
    color: "#4EB3CF",
  },
  {
    img: f_illustration_5,
    title: "LIVE CODING AND PROJECT IMPLEMENTATION",
    points: [
      "Code Review and implementation of OTT Platform",
      "Make and Deploy a project from Scratch",
    ],
    color: "#326F96",
  },
];

export const backend_data = [
  {
    img: b_illustration_1,
    title: "Introduction to Backend Development and Databases",
    points: [
      `Introduction to Backend Development and its role in web applications.`,
      `MySQL Fundamentals`,
      `MongoDB Basics`,
    ],
    color: "#008957",
  },
  {
    img: b_illustration_2,
    title: "Building Backend with Node.js and MySQL",
    points: [
      `Setting Up Node.js Environment`,
      `Creating RESTful APIs with Node.js`,
      `Integrating MySQL with Node.js`,
    ],
    color: "#7C44B6",
  },
  {
    img: b_illustration_3,
    title: "Building Backend with Node.js and MongoDB",
    points: [
      `MongoDB with Node.js - Basic Operations`,
      `Building RESTful APIs with MongoDB`,
      `Advanced MongoDB Concepts`,
    ],
    color: "#0038FF",
  },
  {
    img: b_illustration_4,
    title: "Advanced Topics and Final Project",
    points: [
      `Authentication and Authorization`,
      `Error Handling and Logging`,
      `Deploying Backend Applications`,
      `Final Project`,
    ],
    color: "#4EB3CF",
  },
];

export const android_data = [
  {
    img: a_illustration_1,
    title: "Introduction to Mobile App Development",
    points: [
      `Understanding Mobile App Ecosystem`,
      `Introduction to Flutter and Dart`,
      `Setting Up Flutter Development Environment`,
    ],
    color: "#008957",
  },
  {
    img: a_illustration_2,
    title: "Building User Interfaces",
    points: [
      `Basics of Flutter Widgets`,
      `Styling and Layouts in Flutter`,
      `Navigation and Routing in Flutter`,
    ],
    color: "#7C44B6",
  },
  {
    img: a_illustration_3,
    title: "Working with Data",
    points: [
      `Introduction to State Management`,
      `Managing State with SetState`,
      `Exploring Packages and APIs`,
      `Fetching and Displaying Data`,
    ],
    color: "#0038FF",
  },
  {
    img: a_illustration_4,
    title: "Creating Interactive Apps",
    points: [
      `Handling User Input`,
      `Building Forms and Validation`,
      `Adding Animations and Transitions`,
      `Building a Complete Flutter App`,
    ],
    color: "#4EB3CF",
  },
  {
    img: a_illustration_5,
    title: "Live Coding and Project Implementation",
    points: [
      `Testing and Debugging`,
      `Polish your projects, ensuring smooth functionality and clean code.`,
      `Prepare a presentation to showcase your task management and weather apps.`,
    ],
    color: "#326F96",
  },
];

export const ui_ux_data = [
  {
    img: u_illustration_1,
    title: "Introduction to UI and UX",
    points: [
      "UI/UX Fundamentals",
      "What is UX and UI Design ? The difference between the two",
      "Styling with CSS Implementation",
    ],
    color: "#008957",
  },
  {
    img: u_illustration_2,
    title: "UX Designing",
    points: [
      "UX Design: User Persona",
      "UX Design: User Research",
      "UX Design: User Flow, Wireframes, Prototypes.",
    ],
    color: "#7C44B6",
  },
  {
    img: u_illustration_3,
    title: "UI Designing",
    points: [
      "UI Design: Visual Design Principles",
      "UI Design: Typography, The psychology of colors, How to use colors in UI",
      "Design Thinking: Understanding what matters",
    ],
    color: "#0038FF",
  },
  {
    img: u_illustration_4,
    title: "Designing Process",
    points: [
      "UX/UI Design Process",
      "Case Study: Designing for kids",
      "Responsive Design, Microcopy",
    ],
    color: "#4EB3CF",
  },
  {
    img: u_illustration_5,
    title: "Tips and practice Project",
    points: [
      "Tips: The F-pattern, Button Design, The best Shadows, Correct Labelling",
      "Hands-on Class Project",
    ],
    color: "#326F96",
  },
];

export const services = [
  {
    title: "Frontend Website Development",
    checkPath: "/check_frontend",
    registerPath: "/Register_front",
    data: frontend_data,
    content:
      "HTML and CSS, JavaScript, Front-End Web Development, React (Web Framework), Web Development, User Experience, Algorithms",
    imgLink: webdev,
    amount: 3500,
  },
  {
    title: "Backend Website Development",
    checkPath: "/check_backend",
    registerPath: "/Register_back",
    data: backend_data,
    content:
      "Databases, HTML and CSS, SQL, Database Design, Programming Principles, Back-End Web Development, etc",
    imgLink: backend,
    amount: 4000,
  },
  {
    title: "Android Development",
    checkPath: "/check_appdev",
    registerPath: "/Register_android",
    data: android_data,
    content:
      "Mobile Development, Android Development, Computer Programming, Java programming, Programming Principles, Application Development...",
    imgLink: appdev,
    amount: 4000,
  },
  {
    title: "UI/UX and Product Design",
    checkPath: "/check_uidev",
    registerPath: "/Register_uiux",
    data: ui_ux_data,
    content:
      "User Experience, User Research, Audit, Collaboration, Human Computer Interaction, Product Design, etc...",
    imgLink: ui_ux_new,
    amount: 2000,
  },
];
